export default "__VITE_ASSET__fffk1$Se__"